import ModulesConfig from '@/core/config/ModulesConfig'

/**
 * Whether a user holds the access grant for a given module.
 *
 * `moduleKey` is the internal key from `ModulesConfig`; the check is against the
 * FROZEN grant `name` (e.g. 'Expense Tracker'), which is what is stored per-user
 * in `user_modules` and byte-matched by the backend `require_module` gate. Never
 * compare against the display `label`.
 *
 * Super-admin bypass is the caller's responsibility — this only answers the
 * grant question, mirroring the backend where every query stays owner-scoped.
 */
export function checkModuleAccess(moduleKey: string, modules: string[]): boolean {
  const module = ModulesConfig.find((m) => m.key === moduleKey)
  if (!module) return false
  return modules.includes(module.name)
}
